import { defineSlotRecipe } from '@chakra-ui/react';

const Alert = defineSlotRecipe({
  slots: ['root', 'content'],
  base: {
    root: {
      alignItems: 'center',
    },
    content: {
      gap: 0,
    },
  },
});

export default Alert;
